import { getIsSkillsDeliveryEnabled } from "selectors/features"
import createModule from "../createModule"
import { getLicensedSkills, getProprietarySkills, getSkillCategoryOrder, isSkillsLoaded, isSkillsError } from "./selectors"
import view from "./view"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    skillsEnabled: getIsSkillsDeliveryEnabled(state),
  }),
  required: ["account"],
  data: [
    {
      resource: "licensedSkills",
      as: null,
      passthrough: true,
      url: ({ account, skillsEnabled }) => (skillsEnabled ? `/api/${account}/skills/licensed` : null),
    },
    {
      resource: "proprietarySkills",
      as: null,
      passthrough: true,
      url: ({ account, skillsEnabled }) => (skillsEnabled ? `/api/${account}/skills/proprietary` : null),
    },
  ],
  mapStateToProps: state => ({
    licensedSkills: getLicensedSkills(state),
    proprietarySkills: getProprietarySkills(state),
    skillCategoryOrder: getSkillCategoryOrder(state),
    skillsLoaded: isSkillsLoaded(state),
    skillsError: isSkillsError(state),
  }),
})
